import React from 'react';
import { hotelData } from '../data/hotelData';
import { motion } from 'framer-motion';

const Gallery = () => {
  return (
    <section id="gallery" className="section-padding bg-white overflow-hidden">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="subheading-premium">
            Visual Story
          </span>
          <h2 className="heading-premium">
            Our Gallery
          </h2>
        </div>

        {/* Removed space-y-6 to fix masonry top-alignment glitch */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6">
          {hotelData.gallery.map((img, index) => {
            // Gentle, smooth scattering for a refined "coming together" feel
            const xOffset = index % 3 === 0 ? -80 : index % 3 === 1 ? 80 : 0;
            const yOffset = index % 2 === 0 ? 80 : -80;

            return (
              <div key={index} className="break-inside-avoid mb-6">
                <motion.div
                  initial={{ 
                    opacity: 0, 
                    x: xOffset, 
                    y: yOffset,
                    scale: 0.9,
                  }}
                  whileInView={{ 
                    opacity: 1, 
                    x: 0, 
                    y: 0,
                    scale: 1,
                  }}
                  transition={{ 
                    duration: 1.2,
                    ease: [0.16, 1, 0.3, 1], // Smooth, premium easing (custom easeOut)
                    delay: index * 0.1,
                  }}
                  viewport={{ once: true, margin: "-50px" }}
                  className="relative overflow-hidden rounded-xl group cursor-pointer shadow-[0_4px_10px_rgba(0,0,0,0.05)] hover:shadow-[0_15px_30px_rgba(249,115,22,0.15)] transition-all duration-500"
                >
                  <img 
                    src={img} 
                    alt={`Hotel view ${index + 1}`} 
                    className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-orange-900/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col items-center justify-center">
                    <span className="translate-y-4 group-hover:translate-y-0 transition-transform duration-500 text-white font-serif italic text-2xl drop-shadow-md">
                      View
                    </span>
                    <div className="w-8 h-[1px] bg-orange-400 mt-2 opacity-0 group-hover:opacity-100 transition-all duration-500 delay-100" />
                  </div>
                </motion.div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
